import wcHelper from '@/scripts/helpers/webcall-helper';
import r from '../core';

const mutateOptionsWithDefault = (options) => {
  if (!options.params) { options.params = {}; }
  options.params.per_page = options.params.per_page || 12;
  options.params.current_page = options.params.current_page || 0;
};

const mutateOptionUrl = (options, url) => {
  options.url = API_URL + url;
};

const mutateOption = (options, url) => {
  mutateOptionUrl(options, url);
  mutateOptionsWithDefault(options);
};

export default {
  get(options, callback) {
    mutateOption(options, 'videos');
    return r.get(options, callback);
  },

  getFeatured(options, callback) {
    mutateOptionUrl(options, 'video/featured');
    return r.get(options, callback)
      .then(video => (video.uid != null) ? [video] : [])
      .then(videos => wcHelper.processArray(videos, wcHelper.get.VideoData)[0]);
  },

  search(options) {
    mutateOption(options, 'search');
    return r.get(options);
  },

  getByTags(options) {
    switch (options.type) {
      case 'genre':
      case 'topic':
      case 'country':
        mutateOption(options, `browse/${options.type}/${options.name}`);
        break;
      case 'popular':
      case 'whatsnew':
        mutateOption(options, `browse/${options.type}`);
        break;
      default:
        mutateOption(options, 'browse/whatsnew');
        break;
    }
    return r.get(options);
  },
};
